const H5PMultiChoice = (attempt, parameters = {}) => {
	parameters = JSON.parse(parameters) || {};
	const answers = JSON.parse(attempt.h5p_response.answer) || [];

	const areAnswersVisible = parameters.answers.some(answer => answer.correct !== undefined);

	const generateAnswerHTML = (answer, userAnswer) => {
		const text = answer.text.replace(/<\/?[^>]+(>|$)/g, '').trim();
		const isCorrect = userAnswer?.correct;
		const icon = Object.keys(userAnswer).length > 0
			? `<i class="icon ${isCorrect ? 'correct' : 'incorrect'} pb-heroicons pb-heroicons-solid_${isCorrect ? 'check' : 'x-mark'}"></i>`
			: '';

		return `
            <div>
                <div class="user-answer">${icon}</div>
                <div class="answer">
                    <div class="box">
                        ${answer.correct ? '<i class="icon pb-heroicons pb-heroicons-solid_check"></i>' : ''}
                        <span>${text}</span>
                    </div>
                </div>
            </div>
        `;
	};

	const responses = parameters.answers.map(answer => {
		const text = answer.text.replace(/<\/?[^>]+(>|$)/g, '').trim();
		const userAnswer = answers.find(ans => ans.answer.trim() === text.trim()) || {};
		return generateAnswerHTML(answer, userAnswer);
	});

	return `
        <div class="h5p-multi-choice">
            <div class="heading">
                <div>User's Answer</div>
                <div>Answer</div>
            </div>
            <div class="body">${responses.join('')}</div>
            <div class="explanation">
                ${areAnswersVisible ? `
                    <div class="box correct-answer">
                        <i class="icon pb-heroicons pb-heroicons-solid_check"></i>
                        Correct Answer
                    </div>` : ''
	}
                <div class="box correct">
                    <i class="icon pb-heroicons pb-heroicons-solid_check"></i>
                    User's correct answer
                </div>
                <div class="box incorrect">
                    <i class="icon pb-heroicons pb-heroicons-solid_x-mark"></i>
                    User's incorrect answer
                </div>
            </div>
        </div>
    `;
};

export default H5PMultiChoice;
